import { isPresent } from "@estaly/ui";

export function hasAccessToAdminDashboard(user) {
  return (
    isPresent(user) &&
    (isOrganizationAdmin(user) ||
      isStoreAdmin(user) ||
      isManager(user) ||
      isRegionalManager(user) ||
      isClaimsManager(user) ||
      isAccountingManager(user) ||
      isCustomerSupportManager(user))
  );
}

export function isOrganizationAdmin(user) {
  return isPresent(user) && user.role === "organization_admin";
}

export function isStoreAdmin(user) {
  return isPresent(user) && user.role === "store_admin";
}

export function isManager(user) {
  return isPresent(user) && user.role === "manager";
}

export function isRegionalManager(user) {
  return isPresent(user) && user.role === "regional_manager";
}

export function isClaimsManager(user) {
  return isPresent(user) && user.role === "claims_manager";
}

export function isCustomerSupportManager(user) {
  return isPresent(user) && user.role === "customer_support_manager";
}

export function isAccountingManager(user) {
  return isPresent(user) && user.role === "accounting_manager";
}

export function isResponsible(user) {
  return isPresent(user) && user.role === "responsible";
}

export function isSeller(user) {
  return isPresent(user) && user.role === "seller";
}
